import type { ReactNode } from "react";

interface LayoutProps {
  statusBar: ReactNode;
  map: ReactNode;
  gauges: ReactNode;
  radioDrawer?: ReactNode;
  cameraPanel?: ReactNode;
  benchmark?: ReactNode;
  alertStrip?: ReactNode;
  alertDrawer?: ReactNode;
  connectionBanner?: ReactNode;
}

export function Layout({
  statusBar,
  map,
  gauges,
  radioDrawer,
  cameraPanel,
  benchmark,
  alertStrip,
  alertDrawer,
  connectionBanner,
}: LayoutProps) {
  return (
    <div className="layout">
      <header className="layout-header">{statusBar}</header>

      {connectionBanner}
      {alertStrip}

      <div className="layout-content">
        <main className="layout-main">
          {cameraPanel && <aside className="layout-camera">{cameraPanel}</aside>}
          <div className="layout-right">
            <section className="layout-gauges" aria-label="Live gauges">{gauges}</section>
            <aside className="layout-map" aria-label="Track map">{map}</aside>
          </div>
        </main>

        {benchmark && (
          <footer className="layout-bottom">
            <section className="layout-bottom-panel">{benchmark}</section>
          </footer>
        )}

        {alertDrawer}
        {radioDrawer}
      </div>
    </div>
  );
}
